export default <T extends { preventDefault: () => void }>(callback: (event: T) => any) => (event: T) => {
  event.preventDefault();
  if (callback) return callback(event);
};